<template>
  <div class="kg-menu">
    <!-- 章节区域 -->
    <div class="kg-menu-section">
      <div class="kg-menu-header">
        <div class="kg-menu-header-left">
          <i class="kg-menu-indicator"></i>
          <span class="kg-menu-title">章节</span>
        </div>
        <div
          v-if="chapterListData && chapterListData.length"
          class="kg-menu-header-action"
          @click="handleChapterAll"
        >全局显示</div>
      </div>
      <div class="kg-menu-chapter-body">
        <template v-if="chapterListData && chapterListData.length">
          <KgCollapse :menuData="chapterListData" />
        </template>
        <template v-else>
          <div class="kg-menu-empty">暂无数据</div>
        </template>
      </div>
    </div>

    <!-- 学习路径区域 -->
    <div class="kg-menu-section kg-menu-path-section">
      <div class="kg-menu-header">
        <div class="kg-menu-header-left">
          <i class="kg-menu-indicator"></i>
          <span class="kg-menu-title">学习路径</span>
        </div>
        <div class="kg-menu-header-action">
          <el-tooltip content="添加学习路径" placement="bottom" effect="light">
            <i class="el-icon-plus kg-icon-btn" @click="hanleAction('addPath')"></i>
          </el-tooltip>
        </div>
      </div>
      <div class="kg-menu-path-body">
        <template v-if="hypergraphPathData && hypergraphPathData.length">
          <div
            v-for="(item, index) in hypergraphPathData"
            :key="index"
            class="kg-path-item"
          >
            <div
              class="kg-path-name"
              :class="{ active: btnActiveBus.value == item.id }"
              @click="hanleLearnath(item.id)"
            >{{ item.name }}</div>
            <div class="kg-path-actions">
              <el-tooltip content="添加知识点" placement="bottom" effect="light">
                <i class="el-icon-plus kg-icon-btn blue" @click="onPathAddNode(item)"></i>
              </el-tooltip>
              <el-tooltip content="编辑学习路径" placement="bottom" effect="light">
                <i class="el-icon-setting kg-icon-btn blue" @click="onPathEdit(item)"></i>
              </el-tooltip>
              <el-tooltip content="删除学习路径" placement="bottom" effect="light">
                <i class="el-icon-delete kg-icon-btn red" @click="onPathDel(item)"></i>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="kg-menu-empty">暂无数据</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import KgCollapse from './KgCollapse.vue'

export default {
  name: 'KgMenu',
  components: { KgCollapse },
  inject: [
    'menuActiveBus',
    'btnActiveBus',
    'chapterListData',
    'getknowledgeData',
    'getHypergraphstudypathNodeData',
    'hypergraphPathData',
    'graphAction',
  ],
  methods: {
    hanleLearnath(id) {
      this.menuActiveBus.splice(0, this.menuActiveBus.length)
      if (this.btnActiveBus.value === id) {
        this.btnActiveBus.value = null
        this.getknowledgeData()
      } else {
        this.btnActiveBus.value = id
        this.getHypergraphstudypathNodeData()
      }
    },
    handleChapterAll() {
      this.menuActiveBus.splice(0, this.menuActiveBus.length)
      this.btnActiveBus.value = null
      this.getknowledgeData()
    },
    hanleAction(type, data) {
      this.graphAction(type, data)
    },
    onPathAddNode(item) {
      this.btnActiveBus.value = item.id
      this.getHypergraphstudypathNodeData()
      this.hanleAction('addPathNode', item)
    },
    onPathEdit(item) {
      this.btnActiveBus.value = item.id
      this.getHypergraphstudypathNodeData()
      this.hanleAction('editPath', item)
    },
    onPathDel(item) {
      this.btnActiveBus.value = item.id
      this.getHypergraphstudypathNodeData()
      this.hanleAction('delPath', item)
    },
  },
}
</script>

<style scoped lang="less">
.kg-menu {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 300px;
  z-index: 10;
  display: flex;
  flex-direction: column;
}
.kg-menu-section {
  background: #fff;
  border-radius: 6px;
}
.kg-menu-header {
  height: 48px;
  padding-left: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
}
.kg-menu-header-left {
  display: flex;
  align-items: center;
}
.kg-menu-indicator {
  display: inline-block;
  height: 16px;
  width: 5px;
  border-radius: 4px;
  background: #3e8fff;
  margin-right: 10px;
}
.kg-menu-title {
  font-size: 16px;
  font-weight: bold;
}
.kg-menu-header-action {
  padding-right: 10px;
  color: #3e8fff;
  font-size: 12px;
  cursor: pointer;
}
.kg-menu-chapter-body {
  height: calc(100vh - 440px);
  overflow: hidden;
}
.kg-menu-path-section {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.kg-menu-path-body {
  padding: 10px;
  height: 240px;
  overflow-y: auto;
}
.kg-path-item {
  position: relative;
  padding-right: 70px;
}
.kg-path-name {
  height: 46px;
  line-height: 46px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:hover {
    color: #3e8fff;
  }
  &.active {
    color: #3e8fff;
  }
}
.kg-path-actions {
  font-size: 14px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
}
.kg-icon-btn {
  cursor: pointer;
  margin-right: 4px;
  font-size: 14px;
  &.blue {
    color: #3e8fff;
  }
  &.red {
    color: #f56c6c;
  }
  &:hover {
    opacity: 0.7;
  }
}
.kg-menu-empty {
  padding: 20px;
  text-align: center;
  font-size: 14px;
  color: #999;
}
</style>
